import { JsonProperty } from 'json-typescript-mapper';
import { Image } from './image.model';
import {SaleStatus} from './automobilia.model';

export enum WantedStatus {
  Active = 'Active',
  Purchased = 'Purchased',
  Withdrawn = 'Withdrawn'
}

export class WantedItem {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('title')
  public title?: string;

  @JsonProperty('description')
  public description?: string;

  @JsonProperty('titleEn')
  public titleEn?: string;

  @JsonProperty('descriptionEn')
  public descriptionEn?: string;

  @JsonProperty('images')
  public images?: Array<Image>;

  @JsonProperty('active')
  public active?: boolean;

  @JsonProperty('wantedStatus')
  public wantedStatus?: WantedStatus;

  constructor(
    id?: number,
    title?: string,
    description?: string,
    active?: boolean,
    images?: Array<Image>,
    titleEn?: string,
    descriptionEn?: string,
    wantedStatus?: WantedStatus
  ) {
    this.id = id ? id : null;
    this.title = title ? title : null;
    this.titleEn = titleEn ? titleEn : null;
    this.description = description ? description : null;
    this.descriptionEn = descriptionEn ? descriptionEn : null;
    this.images = images ? images : null;
    this.active = active ? active : null;
    this.wantedStatus = wantedStatus ? wantedStatus : null;
  }
}
